// Reusa as chaves da sidebar para o titulo bater com o item de menu.

export const MOBILE_PAGE_TITLE_FALLBACK_KEY = "mobileHeader.fallback";

const EXACT_TITLE_KEYS: Readonly<Record<string, string>> = {
    "/": "sidebar.home",
    "/dashboard": "sidebar.dashboards",
    "/projects": "sidebar.projects",
    "/financial": "sidebar.financial",
    "/settings": "sidebar.settings",
    "/me": "sidebar.me",
    "/tasks": "dashboard.tasksPanel",
    "/crm/chat": "sidebar.sub.crmChat",
    "/crm/contacts": "sidebar.contact",
    "/admin/submits": "sidebar.sub.accessRequests",
    "/admin/app-builds": "sidebar.appBuilds",
    "/admin/app-hub": "sidebar.appHub",
    "/admin/app-hub/[app]/[environment]/[versionName]": "sidebar.appHub",
    "/admin/app-device/[sessionId]": "sidebar.appBuilds",
    "/admin/app-releases": "sidebar.appReleases",
    "/admin/entregas/[[...slug]]": "sidebar.appHub",
    "/admin/web-qa": "mobileHeader.webQa",
    "/admin/errors": "sidebar.errors",
    "/admin/website-editor": "sidebar.sub.website",
    "/platform/tenants": "sidebar.platform",
    "/platform/tenants/[id]": "sidebar.platform",
    "/platform/tenants/new": "sidebar.platform",
    "/platform/reports": "sidebar.platform",
    "/platform/reports/templates": "sidebar.platform",
    "/platform/reports/templates/[id]": "sidebar.platform",
    "/platform/reports/playground": "sidebar.platform",
    "/platform/storage": "sidebar.platform",
    "/convite/[token]": "mobileHeader.invitation",
    "/suporte": "mobileHeader.supportSession",
    "/step-purchase-orders": "stepPurchaseOrders.title",
    "/history": "mobileHeader.history",
    "/project-diary": "mobileHeader.projectDiary",
    "/project-costs": "mobileHeader.projectCosts",
    "/document-extractions": "sidebar.documentExtractions",
    "/system-profiles": "mobileHeader.systemProfiles",
    "/permissions": "mobileHeader.permissions",
    "/project-roles": "mobileHeader.permissions",
    "/project-permissions": "mobileHeader.permissions",
    "/editor": "mobileHeader.editor",
};

const SECTION_TITLE_KEYS: ReadonlyArray<readonly [prefix: string, key: string]> = [
    ["/inventory", "sidebar.inventory"],
    ["/users", "sidebar.users"],
    ["/tickets", "mobileHeader.tickets"],
    ["/crm/call", "sidebar.sub.crmChat"],
];

export function getMobilePageTitleKey(pathname: string): string {
    const exact = EXACT_TITLE_KEYS[pathname];
    if (exact) return exact;

    const section = SECTION_TITLE_KEYS.find(
        ([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    );
    return section ? section[1] : MOBILE_PAGE_TITLE_FALLBACK_KEY;
}
